<template>
  <div>
    <el-radio-group v-model="currentValue" :disabled="disabled" @input="handleModelInput">
      <el-radio :label="true">{{ $t(trueText) }}</el-radio>
      <el-radio :label="false">{{ $t(falseText) }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trueText: {
      type: String,
      default: 'common.yes'
    },
    falseText: {
      type: String,
      default: 'common.no'
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  methods: {
    handleModelInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="scss">
.el-radio__input.is-checked + .el-radio__label {
  color: black;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: black;
  background: black;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
